import * as React from "react"
import {Suspense} from "react"
import {Col, Container, Row} from "react-bootstrap";
import {InView} from "react-intersection-observer";
import {SkeletonCarousel} from "../../../components/skeletonCarousel";
import {WorksWellWith} from "./carousels/worksWellWith";
import {Collection} from "./carousels/collection";
import {Recommendations} from "./carousels/recommendations";
import {RecentlyViewed} from "./carousels/recentlyViewed";
import {ErrorBoundary} from "@sentry/react";

export const CrossSells = () => {
    return (
        <div id="cross-sells" className="bg-light p-3 mt-5">
            <Container fluid="lg" className="gx-0">
                <Row>
                    <InView triggerOnce={true}>
                        {({inView, ref}) => (
                            <Col ref={ref} className="p-0">
                                {inView &&
                                    <>
                                        <Suspense fallback={<SkeletonCarousel/>}>
                                            <ErrorBoundary fallback={<></>}>
                                                <WorksWellWith/>
                                            </ErrorBoundary>
                                        </Suspense>
                                        <Suspense fallback={<SkeletonCarousel/>}>
                                            <ErrorBoundary fallback={<></>}>
                                                <Collection/>
                                            </ErrorBoundary>
                                        </Suspense>
                                        <Suspense fallback={<SkeletonCarousel/>}>
                                            <ErrorBoundary fallback={<></>}>
                                                <Recommendations/>
                                            </ErrorBoundary>
                                        </Suspense>
                                        <Suspense fallback={<SkeletonCarousel/>}>
                                            <ErrorBoundary fallback={<></>}>
                                                <RecentlyViewed/>
                                            </ErrorBoundary>
                                        </Suspense>
                                    </>
                                }
                            </Col>
                        )}
                    </InView>
                </Row>
            </Container>
        </div>
    )
}